<template>
    <SparkListItem
        :subtext="$t('next_gen.widgets.student_due_work.due_date', { date: formattedDate })"
        :class="{ 'cursor-pointer': item.link }"
        :bottom-divider="!isLast ? 'full' : null"
        @click="onClick"
    >
        <template
            v-if="item.type"
            #eyebrow
        >
            <SparkListItemEyebrowBadges :badges="badges" />
        </template>
        <template
            v-if="item.title"
            #title
        >
            <UIHtml
                :html="item.title"
                class="prose leading-5 text-[length:inherit] text-inherit"
                style="overflow-wrap: anywhere;"
            />
        </template>
        <template
            v-if="item.body"
            #description
        >
            <div
                class="content-sm-ux-regular mb"
            >
                <UIHtml
                    :html="item.body"
                    class="prose leading-5 text-[length:inherit] text-inherit"
                    style="overflow-wrap: anywhere;"
                />
            </div>
        </template>
    </SparkListItem>
</template>

<script setup>
    import { useRouter } from 'vue-router'
    import dayjs from '@/dayjs'

    import UIHtml from '@/components/ui/UIHtml.vue'
    import SparkListItem from '@/components/ui/SparkListItem.vue'
    import SparkListItemEyebrowBadges
        from '@/components/ui/SparkListItem/SparkListItemEyebrowBadges.vue'

    const props = defineProps({
        item: Object,
        isLast: Boolean,
    })
    const router = useRouter()
    const moduleHelpers = useModuleHelpers()

    const clicking = ref(false)

    const dueDate = computed(() => {
        return dayjs(props.item.due_date)
    })

    const formattedDate = computed(() => {
        return dueDate.value.format('D MMM')
    })

    const badges = computed(() => {
        if (!props.item.type) {
            return []
        }
        return [
            {
                text: props.item.type,
                color: 'base',
            },
        ]
    })

    const onClick = () => {
        if (clicking.value || !props.item.link) {
            return
        }

        clicking.value = true
        moduleHelpers.openModuleOrOpenBrowserForLinkData(router, props.item.link)
            .catch((e) => {
                console.log('Failed to open link', e)
            })
            .finally(() => {
                clicking.value = false
            })
    }
</script>
